import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

export const provider = new GoogleAuthProvider();
provider.addScope('https://www.googleapis.com/auth/userinfo.email');
provider.addScope('https://www.googleapis.com/auth/userinfo.profile');

provider.setCustomParameters({
  prompt: 'select_account',
});

// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig =
  window.location.hostname.includes('gpanel.promevo.com') ||
  window.location.hostname.includes('promevo-gpanelds.appspot.com')
    ? {
        apiKey: 'AIzaSyCrpFLQkJoIwrX-vNGpbEzMi-S59apgBt8',
        authDomain: 'promevo-gpanelds.firebaseapp.com',
        databaseURL: 'https://promevo-gpanelds.firebaseio.com',
        projectId: 'promevo-gpanelds',
        storageBucket: 'promevo-gpanelds.appspot.com',
        messagingSenderId: '1004212365559',
        appId: '1:1004212365559:web:e9b27e8594f30ea59a4bf2',
      }
    : {
        apiKey: 'AIzaSyAll-Qu8Iu6BbO3lG1rN1XOHOLQSiajEXc',
        authDomain: 'gpanelqa.firebaseapp.com',
        databaseURL: 'https://gpanelqa-default-rtdb.firebaseio.com',
        projectId: 'gpanelqa',
        storageBucket: 'gpanelqa.firebasestorage.app',
        messagingSenderId: '21973469708',
        appId: '1:21973469708:web:5fb57026f30b4865f7bc29',
      };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);
export const auth = getAuth(app);
